// Mirrors NONE_SENTINEL in quality-service's campaign-analytics.constants.ts — the value the
// backend uses for the "no value set" option in a filter's option list.
export const NONE_SENTINEL = '__none__';

// Label for that option, per filter key. Keys must match the backend's NONE_OPTION_FIELDS;
// a field the backend offers the option for but that is missing here renders the raw sentinel.
export const NONE_LABELS = {
  campaignReviewStatus: 'None',
  assigneeReviewer: 'Unassigned',
  resolution: 'None',
};
